import NAME from "./constants";

export const RESET_STATE = NAME + "/RESET_STATE";

export const CREATE = NAME + "/CREATE";
export const CREATE_FULFILLED = NAME + "/CREATE_FULFILLED";
export const CREATE_REJECTED = NAME + "/CREATE_REJECTED";
